var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import classNames from 'classnames';
import { MDCMenu } from '@material/menu';
import { MDCRipple } from '@material/ripple';
import './menu.css';
import { isDefined } from '@bestadapted/utility';
export var MenuAnchor = 'mdc-menu-surface--anchor';
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initMenu = function (menuEl) {
            if (!menuEl)
                return;
            _this.menuEl = menuEl;
            _this.menu = new MDCMenu(menuEl);
            _this.menu.setFixedPosition(_this.props.fixed ? _this.props.fixed : false);
            _this.setAbsolutePosition();
        };
        _this.handleSelected_ = function (evt) { return _this.handleSelected(evt); };
        _this.handleCancel_ = function () { return _this.handleCancel(); };
        return _this;
    }
    Menu.prototype.setAbsolutePosition = function () {
        var _a, _b, _c;
        if (isDefined((_a = this.props.absolute) === null || _a === void 0 ? void 0 : _a.x) &&
            isDefined((_b = this.props.absolute) === null || _b === void 0 ? void 0 : _b.y)) {
            (_c = this.menu) === null || _c === void 0 ? void 0 : _c.setAbsolutePosition(this.props.absolute.x, this.props.absolute.y);
        }
    };
    Menu.prototype.componentDidMount = function () {
        if (this.menuEl) {
            this.menuEl.addEventListener('MDCMenu:selected', this.handleSelected_);
            this.menuEl.addEventListener('MDCMenuSurface:closed', this.handleCancel_);
        }
    };
    Menu.prototype.componentDidUpdate = function () {
        if (this.menu) {
            this.menu.open = !!this.props.open;
        }
        this.setAbsolutePosition();
    };
    Menu.prototype.componentWillUnmount = function () {
        if (this.menuEl) {
            this.menuEl.removeEventListener('MDCMenu:selected', this.handleSelected_);
            this.menuEl.removeEventListener('MDCMenuSurface:closed', this.handleCancel_);
        }
        if (this.menu)
            this.menu.destroy();
    };
    Menu.prototype.handleSelected = function (evt) {
        if (this.props.handleSelected) {
            this.props.handleSelected(evt.detail);
        }
    };
    Menu.prototype.handleCancel = function () {
        if (this.props.handleCancel) {
            this.props.handleCancel();
        }
    };
    Menu.prototype.render = function () {
        var classes = classNames('mdc-menu', 'mdc-menu-surface', {
            'mdc-menu-surface--open': this.props.defaultOpen
        }, this.props.className);
        return (React.createElement("div", { className: classes, tabIndex: this.props.open ? 0 : -1, ref: this.initMenu, style: this.props.style },
            React.createElement("ul", { className: "mdc-list", role: "menu", "aria-hidden": "true", "aria-orientation": "vertical", tabIndex: -1 }, this.props.children)));
    };
    return Menu;
}(React.Component));
export { Menu };
var MenuItem = /** @class */ (function (_super) {
    __extends(MenuItem, _super);
    function MenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initRipple = function (rippleEl) {
            return (_this.ripple = rippleEl && new MDCRipple(rippleEl));
        };
        return _this;
    }
    MenuItem.prototype.componentWillUnmount = function () {
        if (this.ripple)
            this.ripple.destroy();
    };
    MenuItem.prototype.render = function () {
        var classes = classNames('mdc-list-item', {
            'mdc-list-item--disabled': this.props.disabled
        });
        return (React.createElement("li", { className: classes, role: "menuitem", ref: this.initRipple },
            React.createElement("span", { className: "mdc-list-item__ripple" }),
            React.createElement("span", { className: "mdc-list-item__text" }, this.props.name)));
    };
    return MenuItem;
}(Component));
export { MenuItem };
export var MenuDivider = function () {
    return React.createElement("li", { className: "mdc-list-divider", role: "separator" });
};
//# sourceMappingURL=Menu.js.map